import { extractScheduleNames } from "./callFlowUtils";
export const formatScheduleName = (name) => {
    if (name.length <= 25)
        return name;
    if (name.includes(" - ") && name.includes(":")) {
        const parts = name.split(" - ");
        if (parts.length >= 3 && parts[1] && parts[2]) {
            const dept = parts[1].trim();
            const eventPart = parts[2].split(":")[0];
            const eventType = eventPart ? eventPart.trim() : parts[2].trim();
            const shortName = `${dept} ${eventType}`;
            return shortName.length <= 25 ? shortName : shortName.substring(0, 22) + "...";
        }
    }
    return name.substring(0, 22) + "...";
};
export const getDistinctScheduleNames = (interactions) => {
    if (!interactions)
        return [];
    const scheduleNames = new Set();
    interactions.forEach((interaction) => {
        if (interaction.CallFlow) {
            const schedules = extractScheduleNames(interaction.CallFlow);
            schedules.forEach((scheduleName) => {
                if (scheduleName) {
                    scheduleNames.add(scheduleName);
                }
            });
        }
    });
    return Array.from(scheduleNames).sort();
};
export const getDistinctObjectNames = (interactions) => {
    if (!interactions)
        return [];
    const names = new Set(interactions
        .map((i) => i.ToFilterObjectName)
        .filter((name) => name !== undefined && name !== null && name !== ""));
    return Array.from(names).sort();
};
//# sourceMappingURL=scheduleNameUtils.js.map